// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import manageUsers from './manageUsers';

import { IRoute } from '../';

const manageUsersRoutes: IRoute[] = [
    {
        crumbText: 'manage_users',
        component: manageUsers,
        exact: true,
        path: '/manageUsers',
    },
];

export default manageUsersRoutes;
